import { ExportIcon } from "allIcons";
import { MainButton, SecondaryHeading } from "commonUI";
import { PluginVersion } from "enums";
import { t } from "i18next";

export default function ApiKeyCard({ className, ...props }) {
  const handleDownloadPlugin = () => {
    window.open(
      `https://api.wpsitelauncher.com/download/wp-sitelauncher-${PluginVersion}.zip`,
      "_blank"
    );
  };

  return (
    <>
      <div
        className={`site-card border-2 border-theme-card-bg rounded-5 ${className}`}
      >
        <div>
          <SecondaryHeading>{t("sites.apiKeyDetail.title")}</SecondaryHeading>
          <p className="body-text m-0 !mt-1-5">
            {t("sites.apiKeyDetail.body")}
          </p>
          <MainButton className="mt-3" onClick={handleDownloadPlugin}>
            <ExportIcon />
            {t("sites.apiKeyDetail.downloadPluginButton")}
          </MainButton>
        </div>
        {/* <div className="w-full">
          <SecondaryHeading>
            {t("sites.apiKeyDetail.keyView.Title")}
          </SecondaryHeading>
          {props.apikey && (
            <div className="flex flex-row gap-10 justify-between items-center mt-1 w-full">
              <InputField
                value={props.apikey}
                className="flex-1"
                isLoading={props.isLoading}
              />
              {!props.isLoading && (
                <MainButton
                  className="-mt-2"
                  onClick={() => {
                    navigator.clipboard.writeText(props.apikey);
                    notification({
                      type: "SUCCESS",
                      message: t("sites.apiKeyDetail.keyView.copyMessage"),
                    });
                  }}
                >
                  {t("sites.apiKeyDetail.keyView.copyButton")}
                </MainButton>
              )}
            </div>
          )}
        </div> */}
      </div>
    </>
  );
}
